import {useEffect, useState} from 'react';
import {useDebounce} from 'use-debounce';

import { GeocodedSuburb } from '../models/middleware';
import {useStores} from '../stores/use-stores';

const useSuburbs = () => {
  const {shopSelectionStore} = useStores();
  const [searchText, setSearchText] = useState('');
  const [debouncedSearchText] = useDebounce(searchText, 300);

  useEffect(() => {
    const searchSuburbs = async () => {
      await shopSelectionStore.clearSuburbList();
      await shopSelectionStore.loadSuburbList(debouncedSearchText);
    };
    searchSuburbs();
  }, [debouncedSearchText, shopSelectionStore]);

  const handleSearchTextChange = (text: string) => {
    // Sanitise text to remove anything that's not alphanumeric, space or hyphen.
    const filter = /[^0-9a-zA-Z- ']/gi;
    const newTerm = text.replace(filter, '');

    // Avoid API call for searchText same term
    if (newTerm.length > 1 && newTerm !== searchText) {
      setSearchText(newTerm);
    }
  };

  const list = shopSelectionStore.suburbList.map<GeocodedSuburbExtended>((suburb: GeocodedSuburb) => ({
    ...suburb,
    id: `${suburb.locality}-${suburb.administrative_area}-${suburb.postal_code}`,
    label: `${suburb.locality} ${suburb.administrative_area} ${suburb.postal_code}`,
  }));

  return {
    isLoading: shopSelectionStore.suburbListLoading,
    list,
    search: handleSearchTextChange,
  };
};

export type GeocodedSuburbExtended = GeocodedSuburb & {
  id: string;
  label: string;
};

export default useSuburbs;
